import apiClient from './apiClient';

/**
 * Obtiene las categorías disponibles
 */
export const getCategories = async () => {
  const token = localStorage.getItem('accessToken');
  const response = await apiClient.get(`/categories/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};
